import { useState } from "react";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Marquee from "@/components/Marquee";
import Hero from "@/components/sections/Hero";
import Audiences from "@/components/sections/Audiences";
import Emotional from "@/components/sections/Emotional";
import BuilderConfidence from "@/components/sections/BuilderConfidence";
import Craftsmanship from "@/components/sections/Craftsmanship";
import Process from "@/components/sections/Process";
import Portfolio from "@/components/sections/Portfolio";
import Transformations from "@/components/sections/Transformations";
import TradePartnership from "@/components/sections/TradePartnership";
import Value from "@/components/sections/Value";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  const [bookOpen, setBookOpen] = useState(false);
  const [initialAudience, setInitialAudience] = useState("homeowner");

  const openBooking = (audience) => {
    setInitialAudience(audience);
    setBookOpen(true);
  };

  return (
    <main className="bg-cream text-charcoal">
      <SmoothScroll />
      <Nav
        onBookClick={() => openBooking("homeowner")}
        onTradeClick={() => openBooking("builder")}
      />
      {/* The promise */}
      <Hero />
      <Audiences />
      <Emotional />
      {/* Editorial band — slow, cinema-wide manifesto */}
      <section
        aria-hidden
        data-testid="editorial-band"
        className="relative bg-charcoal text-cream py-10 md:py-14 border-y border-cream/10 overflow-hidden"
      >
        <Marquee
          items={[
            "Kitchens",
            "Wardrobes",
            "Vanities",
            "Made in our own factory",
            "Delivered on time",
            "Est. Sydney",
          ]}
          duration={70}
        />
      </section>
      <BuilderConfidence />
      {/* The craft */}
      <Craftsmanship />
      <Process />
      {/* The work + the proof */}
      <Portfolio />
      <Transformations />
      <TradePartnership />
      {/* The numbers */}
      <Value />
      {/* The ask */}
      <FinalCTA
        open={bookOpen}
        setOpen={setBookOpen}
        initialAudience={initialAudience}
        onOpenAudience={openBooking}
      />
      <Footer />
    </main>
  );
}
